import { render } from "./AddInitiator.vue?vue&type=template&id=70ba4661"
import script from "./AddInitiator.vue?vue&type=script&lang=js"
export * from "./AddInitiator.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__